import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router-dom";
import { useConfig } from "../../context/ConfigContext";
import { track } from "../../Services/Analytics";
import LoadingScreen from "../LoadingScreen";
import { StartOverlay, StartContainer, StartMediaImg, StartVideo } from "./styled";

// Intro/attract screen: full-screen media (image or .mp4, set in the admin) with
// a centered START button. START enters the Localidades (Home) flow — unless there
// is exactly one enabled empreendimento, in which case it opens that detail directly.
// Media + entry routing come from the app config loaded once in ConfigContext.
const Start = () => {
  const history = useHistory();
  const { appConfig } = useConfig();

  const isLoading = !appConfig.loaded;
  const media = appConfig.media;
  const detailPath = appConfig.detail_path;
  const buttonLabel = appConfig.startButtonLabel || "Start";
  const buttonCss = appConfig.startButtonCss || "";

  // The button's only styling: the CSS from the admin Config page (seeded from
  // the server default), injected into <head>. The button renders only after
  // config has loaded, so it's styled from first paint. Appended as textContent
  // (not markup) — no HTML-injection surface.
  useEffect(() => {
    if (!buttonCss.trim()) return undefined;
    const el = document.createElement("style");
    el.setAttribute("data-start-button-css", "");
    el.textContent = buttonCss;
    document.head.appendChild(el);
    return () => {
      document.head.removeChild(el);
    };
  }, [buttonCss]);

  // Back on the attract screen (Home/logo button, idle reset, app start): the
  // visit in progress, if any, is over for the metrics.
  useEffect(() => {
    track.startScreen();
  }, []);

  const handleStart = () => {
    track.home();
    // detailPath is set (server-side) only when a single empreendimento is enabled.
    history.push(detailPath || "/home");
  };

  return (
    <>
      {isLoading ? <LoadingScreen /> : null}

      {media
        ? // Portal the media to <body> so it covers the whole window, past the
          // Stage's scaled/letterboxed canvas — no app background shows.
          ReactDOM.createPortal(
            <StartOverlay>
              {media.type === "video" ? (
                <StartVideo src={media.url} autoPlay muted loop playsInline />
              ) : (
                <StartMediaImg src={media.url} alt="" />
              )}
              <button className="start-button" onClick={handleStart}>
                {buttonLabel}
              </button>
            </StartOverlay>,
            document.body
          )
        : // No media set: normal in-canvas screen over the Stage background.
          !isLoading && (
            <StartContainer>
              <button className="start-button" onClick={handleStart}>
                {buttonLabel}
              </button>
            </StartContainer>
          )}
    </>
  );
};

export default Start;
